import React, { useEffect, useState } from "react";
import { FaArrowLeft } from "react-icons/fa6";
import InitiateInvokeModal from "../LoanAction/Invoke/InitiateInvokeModal";
import CancelInvokeModal from "../LoanAction/Invoke/CancelInvokeModal";
import LoanDetailsCard from "../../components/LoanDetailsCard";
import LoanDetailsCardOd from "../../components/LoanDetailsCardOd";
import axios from "axios";
import InitiateRevokeModal from "../LoanAction/Revoke/InitiateRevokeModal";
import CancelRevokeModal from "../LoanAction/Revoke/CancelRevokeModal";
import ImageLoading from "../../components/ImageLoading";
import PartOrderLoanTable from "../LoanAction/Revoke/PartOrderLoanTable";
function PartSingleOrderView({
  orderId,
  userId,
  partial,
  closeLoanView,
  isOd,
  setIndexRerender,
  setPartUserView,
}) {
  const [initiateModal, setInitiateModal] = useState(false);
  const [readOnly, setReadOnly] = useState(false);
  const [reRender, setReRender] = useState(false);
  const [cancelModal, setCancelModal] = useState(false);
  const [imageLoading, setImageLoading] = useState(false);
  const [data, setData] = useState({});
  const [state, setState] = useState("");
  const [showRevokeModal, setShowRevokeModal] = useState(false);
  const [showCancelRevokeModal, setShowCancelRevokeModal] = useState(false);
  const [orderArray, setOrderArray] = useState([]);

  const [tableArray, setTableArray] = useState([]);
  const [noData, setNoData] = useState(false);
  const [dataOd, setDataOd] = useState({});
  const fetchSingleOrder = async () => {
    setImageLoading(true);
    const token = localStorage.getItem("token");
    const options = {
      method: "GET",
      headers: { Authorization: token },
    };
    let url;
    url = `${process.env.REACT_APP_URL}/lender/v1/orders/${orderId}?id=${userId}`;
    try {
      const res = await axios.request(url, options);
      handleAPIResponse(res);
    } catch (error) {
      console.log(error);
    } finally {
      setImageLoading(false);
    }
  };
  const handleAPIResponse = (res) => {
    if (res?.error) {
      setNoData(true);
      return;
    }
    if (isOd) {
      setDataOd(res?.data?.data);
    } else {
      setData(res?.data);
      setOrderArray(res?.data?.order_detail?.order_uuid);
    }
    setNoData(false);
  };
  const fetchOrderTable = async () => {
    setImageLoading(true);
    const token = localStorage.getItem("token");
    const options = {
      method: "GET",
      headers: { Authorization: token },
    };
    let url;

    url = `${process.env.REACT_APP_URL}/lender/v1/orders/${orderId}/partial_order_show`;

    try {
      const res = await axios.request(url, options);
      if (res?.data?.error) {
        setTableArray([]);
        return;
      }
      setTableArray(res.data?.data?.order_details);

      // setRowsPerPage(res.data.user_details.length);
    } catch (error) {
      console.log(error);
    } finally {
    }
  };

  const setOrderColor = (status) => {
    const failedStatuses = [
      "Loan Not Disbursed",
      "Invoke Failed",
      "Revoke Failed",
      "Market Invoke",
      "Overdue EMI",
      "90 DPD",
      "failed",
      "Failed",
      "Margin Call",
    ];
    const initiatedStatuses = ["Revocation Initiated", "Invocation Initiated"];

    if (failedStatuses.includes(status)) {
      return "bg-[#d30d00]";
    }
    if (initiatedStatuses.includes(status)) {
      return "bg-[#d3bf05]";
    }
    return "bg-[#0ba300]";
  };

  useEffect(() => {
    fetchSingleOrder();
    fetchOrderTable();
  }, [reRender]);
  return (
    <>
      {imageLoading && (
        <div className="mt-4 w-full  h-[calc(100vh-180px)] flex justify-center items-center  bg-white rounded-lg p-4">
          <ImageLoading />
        </div>
      )}
      {!imageLoading && (
        <div className=" mt-4 w-full  h-full  bg-white rounded-lg px-4 pb-4 relative">
          <div className="sticky bg-white top-0 left-0 py-4 border-b border-[#e2ecff]">
            <div className="flex items-center justify-between ">
              <button
                className="text-[#00394d] text-sm font-bold flex items-center"
                onClick={() => closeLoanView()}
              >
                <span className=" mr-2">
                  <FaArrowLeft style={{ width: "18px", height: "18px" }} />
                </span>
                Back
              </button>
              <div className="w-full flex justify-between ml-4">
                {!isOd ? (
                  <div className="flex items-center">
                    <p className=" text-base font-semibold mr-4">
                      {data?.order_detail?.order_reference_no || "---"}
                    </p>
                    <div className=" border rounded-xl mr-3 px-2 py-1 border-black inline-flex items-center font-medium text-xs ">
                      <span
                        className={` w-[10px] h-[10px] rounded-full ${setOrderColor(
                          data?.order_detail?.loan_details?.action_status
                            ?.status || "--"
                        )} block mr-[10px]`}
                      ></span>{" "}
                      {data?.order_detail?.loan_details?.action_status.status ||
                        "--"}{" "}
                    </div>
                    <p className="text-[12px] text-[#8b8b8b] font-medium">
                      on{" "}
                      {data?.order_detail?.loan_details?.action_status.date ||
                        "--"}{" "}
                    </p>
                  </div>
                ) : (
                  <div className="flex items-center ">
                    <p className=" text-base font-semibold mr-4">
                      {dataOd?.overdraft_detail?.order_reference_no || "---"}
                    </p>
                    <div className=" border rounded-xl mr-3 px-2 py-1 border-black inline-flex items-center font-medium text-xs ">
                      <span
                        className={` w-[10px] h-[10px] rounded-full ${setOrderColor(
                          dataOd?.overdraft_detail?.action_status?.status ||
                            "--"
                        )} block mr-[10px]`}
                      ></span>{" "}
                      {dataOd?.overdraft_detail?.action_status.status || "--"}{" "}
                    </div>
                    <p className="text-[12px] text-[#8b8b8b] font-medium">
                      on {dataOd?.overdraft_detail?.action_status.date || "--"}{" "}
                    </p>
                  </div>
                )}
                {/* {!partial && (
                  <div className=" flex items-center">
                    {data.order_detail?.loan_details?.action_status.buttons.includes(
                      "prepayment_link"
                    ) &&
                      !copied && (
                        <ActionCancelButton
                          setInvokeModal={setCancelModal}
                          text={"Prepayment Link"}
                          style={`mr-2`}
                          onClick={() => {
                            handleCopy(data.order_detail?.prepayment_link);
                          }}
                          Icon={CopyButton}
                        />
                      )}
                    {copied && (
                      <ActionCancelButton
                        disabled={true}
                        text={"Link Copied"}
                        style={` mr-2 border-[#0ba300] !text-[#0ba300] bg-[white]`}
                        Icon={CheckIcon}
                      />
                    )}
                    {data.order_detail?.loan_details.action_status.buttons.includes(
                      "cancel_invoke"
                    ) && (
                      <ActionCancelButton
                        setInvokeModal={setCancelModal}
                        text={"Cancel Invoke"}
                        style={`mr-4`}
                        onClick={() => setCancelModal(true)}
                      />
                    )}
                    {data.order_detail?.loan_details.action_status.buttons.includes(
                      "cancel_revoke"
                    ) && (
                      <ActionCancelButton
                        setInvokeModal={setShowCancelRevokeModal}
                        text={"Cancel Revoke"}
                        style={`mr-4`}
                        onClick={() => setShowCancelRevokeModal(true)}
                      />
                    )}
                    {data.order_detail?.loan_details.action_status.buttons.includes(
                      "invoke_now"
                    ) && (
                      <ActionBlueButtonOrders
                        text={"Invoke Now"}
                        disabled={false}
                        onClick={() => {
                          setState("initiatedInvocation");
                          setInitiateModal(true);
                        }}
                      />
                    )}

                    {data.order_detail?.loan_details.action_status.buttons.includes(
                      "revoke_now"
                    ) && (
                      <ActionBlueButtonOrders
                        text={"Revoke Now"}
                        onClick={() => {
                          setState("initiatedInvocation");
                          setShowRevokeModal(true);
                        }}
                      />
                    )}
                    {data.order_detail?.loan_details.action_status.buttons.includes(
                      "initiate_invoke"
                    ) && (
                      <ActionBlueButtonOrders
                        text={"Initiate Invoke"}
                        onClick={() => {
                          setInitiateModal(true);
                        }}
                      />
                    )}
                    {data.order_detail?.loan_details.action_status.buttons.includes(
                      "initiate_revoke"
                    ) && (
                      <ActionBlueButtonOrders
                        text={"Initiate Revoke"}
                        onClick={() => {
                          setShowRevokeModal(true);
                        }}
                      />
                    )}
                  </div>
                )} */}
              </div>
            </div>
          </div>
          <div className=" ">
            {isOd ? (
              <LoanDetailsCardOd
                data={
                  dataOd?.overdraft_detail !== null && dataOd?.overdraft_detail
                }
                orderId={orderId}
              />
            ) : (
              <LoanDetailsCard
                data={data?.order_detail !== null && data?.order_detail}
              />
            )}

            {partial && (
              <PartOrderLoanTable
                orderId={orderId}
                tableArray={tableArray}
                reRender={reRender}
                setReRender={setReRender}
                isOd={isOd}
                setIndexRerender={setIndexRerender}
                setPartUserView={setPartUserView}
              />
            )}
          </div>
        </div>
      )}

      {initiateModal && (
        <InitiateInvokeModal
          cancelFunction={setInitiateModal}
          selectedItems={orderArray}
          invocationState={state}
          setReRender={setReRender}
          reRender={reRender}
          setReadOnly={setReadOnly}
        />
      )}
      {cancelModal && (
        <CancelInvokeModal
          cancelFunction={setCancelModal}
          selectedItems={orderArray}
          setReRender={setReRender}
          reRender={reRender}
        />
      )}
      {showRevokeModal && (
        <InitiateRevokeModal
          cancelFunction={setShowRevokeModal}
          selectedItems={orderArray}
          invocationState={state}
          reRender={reRender}
          setReRender={setReRender}
          setReadOnly={setReadOnly}
        />
      )}
      {showCancelRevokeModal && (
        <CancelRevokeModal
          cancelFunction={setShowCancelRevokeModal}
          selectedItems={orderArray}
          setReRender={setReRender}
          reRender={reRender}
        />
      )}
    </>
  );
}

export default PartSingleOrderView;
